module.exports = __webpack_public_path__ + "img/lottery_bg_1.b49cb4ce.png";